import axios from 'axios'
import router from './router'

export default() => {
    const unauthorized = 401;

    var authorization = 'Bearer ';

    if (localStorage.getItem('authenticationToken') !== null) {
        authorization += localStorage.authenticationToken
    }

    const axiosInstance = axios.create({
        // baseURL: 'http://snapshotly.test/api/internal/v1/',
        // baseURL: 'https://apis.snapshot.ly/api/internal/v1/',
        baseURL: 'https://api.weap.io/api/internal/v1/',
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': authorization,
        }
    })

    axiosInstance.interceptors.response.use(response => response, function (error) {
        // If the response has a 401, redirect to the login route
        if (error.response.status == unauthorized) {
            router.push({ name: 'login' });
            return;
        }

        return Promise.reject(error);
    });

    return axiosInstance;
}
